import { cn, formatBytes } from "@/lib/utils";
import {
  formatDateToDanishLocaleOnlyDateLongMonth,
  formatTextString,
} from "@/utils/format";
import {
  Legislation,
  LegislationStatus,
} from "@/models/legislation/Legislation";
import StatusBadge from "@/pages/legislation/components/StatusBadge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@capacit-com/lara-law-shared-ui";
import { SelectedWorkspaceVersion } from "@/models/workspace/Workspace";

interface DocumentPDFHeaderProps {
  legislationStatus?: LegislationStatus;
  legislation?: Legislation;
  workspaceDocument?: SelectedWorkspaceVersion | null;
  documentTitle?: string;
  className?: string;
}

export function DocumentPDFHeader({
  legislationStatus,
  workspaceDocument,
  documentTitle = "",
  className,
}: DocumentPDFHeaderProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-3 w-full py-2 max-w-full",
        className
      )}
    >
      {legislationStatus && <StatusBadge status={legislationStatus} />}

      {documentTitle && (
        <div className="w-0 flex-1 overflow-hidden">
          <TooltipProvider>
            <Tooltip delayDuration={300}>
              <TooltipTrigger asChild>
                <h2
                  className="text-sm font-semibold truncate cursor-default"
                  dangerouslySetInnerHTML={{
                    __html: formatTextString(documentTitle),
                  }}
                />
              </TooltipTrigger>
              <TooltipContent
                side="bottom"
                align="start"
                className="max-w-[350px] text-sm break-words"
              >
                {formatTextString(documentTitle)}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
      )}

      {workspaceDocument && (
        <p className="text-muted-foreground text-sm">
          {workspaceDocument.documentType} {formatBytes(workspaceDocument.size)}{" "}
          {" - "}
          {workspaceDocument.updatedAt &&
            formatDateToDanishLocaleOnlyDateLongMonth(
              new Date(workspaceDocument.updatedAt)
            )}
        </p>
      )}
    </div>
  );
}
